import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AplikasiComponent } from './aplikasi/aplikasi.component';
import { WebsiteComponent } from './website/website.component';
import { CmsComponent } from './cms/cms.component';
import { PembayaranComponent } from './pembayaran/pembayaran.component';
import { RapotComponent } from './rapot/rapot.component';
import { AbsensiComponent } from './absensi/absensi.component';
import { AxcoraschoolComponent } from './axcoraschool/axcoraschool.component';
import { BelajarComponent } from './belajar/belajar.component';
import { GratisComponent } from './belajar/gratis/gratis.component';
import { MediaComponent } from './belajar/media/media.component';
import { PremiumComponent } from './belajar/premium/premium.component';
import { SimpleComponent } from './belajar/simple/simple.component';
import { AxcoraschoolproComponent } from './axcoraschoolpro/axcoraschoolpro.component';

const routes: Routes = [
  { path: '', redirectTo: '/', pathMatch: 'full' },
  { path: '', component: HomeComponent },
    { path: 'home', component: HomeComponent },
    { path: 'aplikasi', component: AplikasiComponent, data: {title: 'Aplikasi sekolah'} }, 
    { path: 'website', component: WebsiteComponent, data: {title: 'Website sekolah'} }, 
    { path: 'cms', component: CmsComponent, data: {title: 'CMS Sekolah'} }, 
    { path: 'pembayaran', component: PembayaranComponent, data: {title: 'Aplikasi Pembayaran Sekolah'} }, 
    { path: 'absensi', component: AbsensiComponent, data: {title: 'Aplikasi absensi siswa Sekolah'} }, 
    { path: 'rapot', component: RapotComponent, data: {title: 'Aplikasi rapot sekolah'} }, 
    { path: 'belajar', component: BelajarComponent, data: {title: 'Aplikasi belajar mengajar e-learning online'} }, 
    { path: 'belajar/gratis', component: GratisComponent, data: {title: 'APlikasi E-learing sekolah gratis download'} }, 
    { path: 'belajar/media', component: MediaComponent, data: {title: 'APlikasi E-learing sekolah download upload media'} }, 
    { path: 'belajar/premium', component: PremiumComponent, data: {title: 'APlikasi E-learing sekolah terbaik'} }, 
    { path: 'belajar/simple', component: SimpleComponent, data: {title: 'APlikasi E-learing sekolah mudah digunakan'} }, 
    { path: 'axcoraschool', component: AxcoraschoolComponent, data: {title: 'Axcora School aplikasi Sekolah terlengkap'} }, 
    { path: 'axcoraschoolpro', component: AxcoraschoolproComponent, data: {title: 'ERP Axcora school Sekolah PRO'} }, 

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
